import type { PropertyOptionalParam } from "web_myplann/Portfolio/Hooks/useGetPropertyOptionalParams";

type BooleanGroup<T> = Record<
	Extract<PropertyOptionalParam<T>["key"], string>,
	boolean
>;

export const toSelectedKeys = <T>(
	params: PropertyOptionalParam<T>[],
	data: Partial<T>,
): string[] =>
	params.filter(({ key }) => data[key]).map(({ key }) => String(key));

export const toBooleanGroup = <T>(
	params: PropertyOptionalParam<T>[],
	selectedKeys: string[],
): BooleanGroup<T> =>
	Object.fromEntries(
		params.map(({ key }) => [String(key), selectedKeys.includes(String(key))]),
	) as BooleanGroup<T>;
